module.exports = __webpack_public_path__ + "img/guiguicode.f8288cf8.jpg";